function toast(message, type = "info") {
  const endSide = document.documentElement.dir === "rtl" ? "right" : "left";
  butterup.toast({
    title: type === "success" ? "Success" : "Error",
    message: message,
    type: type,
    location: "top-" + endSide,
    dismissable: true,
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('[data-product-form]');
  if (!form) return;

  const variantInput = form.querySelector('[name="id"]');
  const quantityInput = form.querySelector('[name="quantity"]');
  const quickBuyBtn = form.querySelector('[data-quick-buy]');
  const addToCartBtn = form.querySelector('[data-add-to-cart]');

  const variants = JSON.parse(form.dataset.variants || "[]");
  const optionsCount = parseInt(form.dataset.optionsCount || 0);

  function getSelectedOptions() {
    const selected = [];
    for (let i = 1; i <= optionsCount; i++) {
      const field = form.querySelector(`[name="option-${i}"]:checked, [name="option-${i}"]`);
      if (field) {
        selected.push(field.value);
      }
    }
    return selected;
  }

  function findMatchingVariant(options) {
    return variants.find(v => JSON.stringify(v.options) === JSON.stringify(options));
  }

  function updateFormState() {
    const selectedOptions = getSelectedOptions();
    const variant = findMatchingVariant(selectedOptions);

    if (variant) {
      variantInput.value = variant.id;
      quickBuyBtn.href = `/cart/${variant.id}:${quantityInput.value}`;

      if (variant.available) {
        addToCartBtn.disabled = false;
        quickBuyBtn.style.pointerEvents = 'auto';
        quickBuyBtn.style.opacity = '1';

        if (variant.inventory_management === "shopify" && variant.inventory_quantity < 10 && variant.inventory_quantity > 0) {
          toast(`Only ${variant.inventory_quantity} left in stock!`, 'info');
        }
      } else {
        toast("This variant is currently out of stock.", "error");
        addToCartBtn.disabled = true;
        quickBuyBtn.style.pointerEvents = 'none';
        quickBuyBtn.style.opacity = '0.5';
      }

    } else {
      toast("The selected combination is not available.", "error");
      addToCartBtn.disabled = true;
      quickBuyBtn.style.pointerEvents = 'none';
      quickBuyBtn.style.opacity = '0.5';
    }
  }

  form.querySelectorAll('[name^="option"]').forEach(input => {
    input.addEventListener('change', updateFormState);
  });

  quantityInput.addEventListener('input', updateFormState);
  updateFormState();
});
